export const noop = () => {
  // do nothing
};

export const wait = async (time: number) =>
  new Promise(res => {
    setTimeout(res, time);
  });
